export default __webpack_public_path__ + "static/media/cancel_red_icon.a8b29d05.svg";